import isDateValid from './isDateValid';

/**
 *
 * @param value
 */
const dateOrNow = (value: string | number): Date => {
  if (!isDateValid(value)) {
    return new Date();
  }

  return new Date(value);
};

export default dateOrNow;
